import { MantineTheme, createStyles } from "@mantine/styles";

export const useStyles = createStyles((theme: MantineTheme) => ({
  container: {
    marginTop: "20px",
  },
  inputBox: {
    width: "406px",
  },
  buttonWrapper: {
    marginTop: theme.spacing.md,
    display: "flex",
    justifyContent: "center",
  },
  buttonDivv: {
    marginTop: "60px",
    display: "flex",
    flexDirection: "row",
    paddingLeft: "0px",
    gap: "30px",
    marginBottom: 20,
  },
}));
